import { useEffect, useState } from "react"
import moment from "moment"
import getAppConfig from "~/utils/getAppConfig"
import { apiWorkspaceBookingAvailableDates } from "~/routes"

type Row = { date: string }

export default function useBookingAvailableDates() {
  const { venueSlug, venue } = getAppConfig()

  const enabled = !!venue?.useBookingAvailableDates
  const [loading, setLoading] = useState(false)
  const [activeDates, setActiveDates] = useState<string[]>([])

  useEffect(() => {
    if (!enabled) {
      setActiveDates([])
      return
    }

    const run = async () => {
      setLoading(true)
      try {
        const url = apiWorkspaceBookingAvailableDates.index.path({ venueSlug })
        const res = await fetch(url, { method: "GET", headers: { Accept: "application/json" } })
        if (!res.ok) return setActiveDates([])

        const body = await res.json()
        const rows: Row[] = body.booking_available_dates || []
        setActiveDates(rows.map((r) => moment(r.date).format("YYYY-MM-DD")))
      } finally {
        setLoading(false)
      }
    }

    run()
  }, [enabled, venueSlug])

  return { enabled, loading, activeDates }
}